import { useCallback } from "react";

import Button from "ds/components/Button";
import useAnalytics from "hooks/useAnalytics";

import { showAzureIntegrationFormDrawer } from "../FormDrawer";

const CreateIntegrationButton = () => {
  const trackAnalytics = useAnalytics();

  const createIntegration = useCallback(() => {
    showAzureIntegrationFormDrawer({ trackAnalytics });
  }, [trackAnalytics]);

  return (
    <Button variant="primary" onPress={createIntegration}>
      Set up integration
    </Button>
  );
};

export default CreateIntegrationButton;
